import { render, staticRenderFns } from "./LawTable.vue?vue&type=template&id=00701da8&scoped=true"
import script from "./LawTable.vue?vue&type=script&lang=js"
export * from "./LawTable.vue?vue&type=script&lang=js"
import style0 from "./LawTable.vue?vue&type=style&index=0&id=00701da8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00701da8",
  null
  
)

export default component.exports